import React from "react";
import { Container, Card } from "react-bootstrap";
import { Award } from "react-bootstrap-icons";
import "./achievements.css";
const Achievements = () => (
  <section id="achievements" className="py-1">
    <Container>
      <h2 className=" mb-4">Achievements</h2>



      {/* Customer Hero Award */}
      <Card className="achievement-card mb-4">
        <Card.Body>
          <div className="d-flex align-items-start">
            <div className="achievement-icon">
              <Award size={32} />
            </div>
            <div>
              <h5 className="fw-bold">
                🏆 Customer Hero Award – APMEA ICD Quarterly Pinnacle Awards (H2 FY26)
              </h5>
              <p className="mb-0">
                Honored with the <strong>Customer Hero Award</strong> under the
                <strong> Customer / Client Centricity Domain Expert Contributor</strong>
                category at the <strong>APMEA ICD Quarterly Pinnacle Awards (H2 FY26)</strong>
                by <strong>Wipro</strong>. This award recognizes outstanding customer
                focus, domain expertise, technical excellence, and consistent
                delivery of high-impact solutions that contributed to customer
                success and business value.
              </p>
            </div>
          </div>
        </Card.Body>
      </Card>

      {/* Recognition Award */}
      <Card className="achievement-card mb-4">
        <Card.Body>
          <div className="d-flex align-items-start">
            <div className="achievement-icon">
              <Award size={32} />
            </div>
            <div>
              <h5 className="fw-bold">Recognition Award – 2024</h5>
              <p className="mb-0">
                I was honored for my <b>commitment</b>, <b>innovation</b>, and <b>dedication</b>,
                achieving a significant professional milestone at <b>Veniso Solutions</b>
                in 2024. This recognition reflects my long-standing contributions
                to full-stack development, leadership, and delivering high-impact
                enterprise solutions.
              </p>
            </div>
          </div>
        </Card.Body>
      </Card>

    </Container>
  </section>
);

export default Achievements;